import {Api} from "./api";
import {readCookie} from "./utm-tracking";

export class StrangeConversions {
	static convertGtmPixelEvent (type, eventId, data = {}) {

		if (!window.siteConfig.hasFacebookConversions) {
			return;
		}

		const formData = new FormData();

		formData.set(window.csrfTokenName, window.csrfTokenValue);
		formData.set('eventId', eventId);
		formData.set('type', type);

		const fbp = readCookie('_fbp');
		if (fbp) {
			formData.set('fbp', fbp);
		}

		const urlSearchParams = new URLSearchParams(window.location.search);
		if (urlSearchParams.has('fbclid')) {
			formData.set('fbc', urlSearchParams.get('fbclid'));
		}

		if (urlSearchParams.has('fbTestCode')) {
			formData.set('fbTestCode', urlSearchParams.get('fbTestCode'));
		}

		for (let key in data) {
			formData.set(key, data[key]);
		}

		Api.fbConvertPixelEvent(formData);
	}

	static generateEventId() {
		let randomness = 1000+Math.round(Math.random() * 8999);

		let eventId = [
			(new Date()).getTime(),                     // timestamp, with millis
			btoa(navigator.userAgent).substring(0,6),   // first 6 chars of base64 userAgent
			randomness                                  // 4 digits of pseudo-randomness
		];

		return eventId.join('.');
	}
}

// make this available globally
window.strangeConversions = StrangeConversions;

// Execute immediately, do not wait for the window load event as we wish to mutate the GTM container load event with an event Id
if (Array.isArray(window.dataLayer)) {
	const gtmLoadEvent = window.dataLayer.find((dataLayerEvent) => dataLayerEvent.hasOwnProperty('event') && dataLayerEvent.event === 'gtm.js');

	if (gtmLoadEvent) {
		gtmLoadEvent.strangeEventId = StrangeConversions.generateEventId();

        window.addEventListener('load', () => {
            StrangeConversions.convertGtmPixelEvent('PageView', gtmLoadEvent.strangeEventId);
        });
    }
}